<template>
  <Transition v-bind="fade" mode="out-in">
    <span v-if="isLoading" class="min-h-[200px] flex">
      <LoadingIcon class="w-10 h-10 m-auto text-primary" />
    </span>
    <span v-else-if="isError" class="flex flex-col items-center mx-auto">
      <!-- Error -->
      <slot name="error">
        <img class="w-32 h-32 mb-3" src="/images/mascot.svg" alt="sad bear" />

        <UIHeading title="Не удалось загрузить" tag="2" styles="4" />
      </slot>
    </span>
    <div v-else>
      <!-- Content -->
      <Transition v-bind="fade" mode="out-in">
        <div
          v-if="(isFiltered && !hasNextPage && !dataLength) || !dataLength"
          :class="
            classes.empty
              ? classes.empty
              : 'flex flex-col items-center mx-auto pt-12 pb-64'
          "
        >
          <slot name="empty">
            <img
              class="w-64 h-64 mb-3"
              src="/images/mascot.svg"
              alt="sad bear"
            />

            <UIHeading
              title="Мы ничего не нашли"
              tag="2"
              styles="4"
              class="mb-2"
            />
            <p class="dark:text-white/50 text-black/50 text-center">
              Попробуйте уточнить ваш запрос или очистите поисковые фильтры.
            </p>
          </slot>
        </div>

        <div v-else>
          <slot name="default" />

          <div
            v-if="
              paginationType === 'infinite' &&
              !(currentPage === 1 && !hasNextPage)
            "
            class="flex justify-center my-14"
          >
            <slot name="button">
              <UIButton
                :title="hasNextPage ? 'Загрузить еще' : 'Вы докрутили до конца'"
                :is-loading="isFetchingNextPage"
                :loading-icon="LoadingIcon"
                :disabled="!hasNextPage"
                size="xl"
                @click="fetchNextPage"
              />
            </slot>
          </div>
          <Pagination
            v-else-if="paginationType !== 'infinite' && dataLength"
            @page-change="(page) => fetchNextPage({ pageParam: page })"
            :total="dataLength"
            :per_page="10"
          />
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script setup>
import Pagination from '@/components/common/Pagination.vue'
import LoadingIcon from '@/components/loading/LoadingIcon.vue'
import UIButton from '@/components/ui/UIButton.vue'
import UIHeading from '@/components/ui/UIHeading.vue'
import { fade } from '@/utils/transitions.js'

defineProps({
  classes: {
    type: Object,
    default: {},
  },
  isFetchingNextPage: {
    type: Boolean,
    default: false,
  },
  hasNextPage: {
    type: Boolean,
    default: false,
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  isError: {
    type: Boolean,
    default: false,
  },
  isFiltered: {
    type: Boolean,
    default: false,
  },
  fetchNextPage: {
    type: Function,
    default: null,
  },
  dataLength: {
    type: [Number, String],
    default: 0,
  },
  paginationType: {
    type: String,
    default: 'infinite',
  },
  currentPage: {
    type: Number,
    default: 1,
  },
})
</script>
